import clsx from "clsx";
import React from "react";
import { CSSTransition, SwitchTransition } from "react-transition-group";
import BuyOnStoreButton from "web/react/components/buy-on-store-button/buy-on-store-button";
import { Price } from "web/react/emo/product-price/price";
import { Sticker } from "web/react/emo/sticker";
import { VStack } from "web/react/emo/v-stack";
import { View } from "web/react/emo/view";
import { useInStockProductPageContext } from "web/react/pages/product/in-stock/in-stock-product-page//in-stock-product-page.context";
import { gettext } from "web/script/modules/django-i18n";
import * as styles from "./fixed-buy-on-store-button.css";

export function FixedBuyOnStoreButton({ showButton, isBefore }): JSX.Element {
    const {
        isLoggedIn,
        product,
        activeProduct: { price },
        activeBuyOption: { buyOption: activeBuyOption, defaultSize },
    } = useInStockProductPageContext();

    const eventLabel = isBefore
        ? "buy-on-store-button-before-main-cta"
        : "buy-on-store-button-after-main-cta";

    return (
        <SwitchTransition mode="out-in">
            <CSSTransition
                classNames={{
                    appear: styles.enter,
                    appearActive: styles.enterActive,
                    enter: styles.enter,
                    enterActive: styles.enterActive,
                    exit: styles.exit,
                    exitActive: styles.exitActive,
                }}
                key={showButton ?? null}
                timeout={250}
            >
                {showButton ? (
                    <View
                        className={clsx(styles.stickyWrapper, {
                            [styles.loggedInStickyWrapper]: isLoggedIn,
                        })}
                        paddingX={"md"}
                        paddingY={"sm"}
                    >
                        <span>
                            <VStack spacing="xxs">
                                <Price {...price} size={"lg"} />
                                <Sticker name={"lowestPrice"} />
                            </VStack>
                        </span>
                        <span className={styles.stickyWrapperButton}>
                            <BuyOnStoreButton
                                productId={product.product_id}
                                leadUrl={defaultSize.lead_url}
                                leadLabel={gettext("product.buy_area.buy_now")}
                                analyticsEventLabel={"is-product-shop-now"}
                                analyticsFunctionEventLabel={eventLabel}
                                productImageUrl={product.images[0].full_size_url}
                                contextType={"shop_now"}
                                hasPromotion={false}
                                retailerSlug={activeBuyOption.retailer_slug}
                            />
                        </span>
                    </View>
                ) : (
                    <></>
                )}
            </CSSTransition>
        </SwitchTransition>
    );
}
